<template>
    <div v-if="visible" class="verify-user-phone-dialog-container">
        <div class="verify-user-phone-dialog">
            <div class="dialog-header">
                <div class="header-title">手机号码验证</div>
                <img src="../assets/verify-phone-close.png" @click="onClose">
            </div>
            <div class="dialog-content">
                <div class="tips">{{ tips }}</div>
                <div class="form">
                    <!-- 显示用户绑定的手机号 -->
                    <div v-if="!modifyPhone" class="form-item">
                        <div class="form-item-label">手机号码</div>
                        <div class="form-item-value">
                            <div class="form-item-content disabled">
                                <span class="user-phone">{{ desensitizationPhone }}</span>
                                <span class="operate" @click="onClickModifyBtn">修改手机号</span>
                            </div>
                        </div>
                    </div>
                    <!-- 用户手动输入新的手机号码 -->
                    <div v-else class="form-item">
                        <div class="form-item-label">手机号码</div>
                        <div class="form-item-value">
                            <div class="form-item-content">
                                <input v-model="formData.phone" maxlength="11">
                            </div>
                            <div class="form-item-error">{{ phoneErrorMessage }}</div>
                        </div>
                    </div>
                    <!-- 用户输入验证码 -->
                    <div class="form-item">
                        <div class="form-item-label">验证码</div>
                        <div class="form-item-value">
                            <div class="form-item-content">
                                <input v-model="formData.smsCode" maxlength="6">
                                <span
                                    :class="['operate', countdown < 60 ? 'time-loading' : '']"
                                    @click="getSmsCode"
                                >{{ verifyText }}</span>
                            </div>
                            <div class="form-item-error">{{ smsCodeErrorMessage }}</div>
                        </div>
                    </div>
                </div>
                <div class="protocol">
                    <span
                        :class="['agree-protocol', isChecked ? 'checked' : '' ]"
                        @click="onClickAgreeBtn"
                    ></span>
                    <span>我已阅读理解并同意</span>
                    <a :href="protocol.href" target="_blank">{{ protocol.text }}</a>
                </div>
            </div>
            <div class="dialog-footer">
                <button class="cancel-btn" @click="onClose">取消</button>
                <button :class="['submit-btn', !isChecked ? 'disabled' : '']" @click="onSubmit">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
import client from '../common/client';
import {Notification} from 'element-ui';
export default {
    props: {
        savedPhone: {
            type: String,
            default: ''
        },
        protocol: {
            type: Object,
            default: () => {
                return {
                    href: 'https://console.bce.baidu.com/iam/agreement-v2.html',
                    text: '《百度智能云线上订购协议》'
                };
            }
        }
    },
    data() {
        return {
            userPhone: '',
            formData: {
                phone: '',
                smsCode: ''
            },
            phoneErrorMessage: '',
            smsCodeErrorMessage: '',
            // 验证码的倒计时
            countdown: 60,
            timer: null,
            visible: false,
            modifyPhone: false,
            isChecked: true,
            tips: '百度智能云会保护您的个人信息，仅有指定的服务商能看到您的联系方式，请您放心提供',
            verifyText: '获取验证码'
        };
    },
    watch: {
        countdown(newValue) {
            if (newValue === 60) {
                this.verifyText = '获取验证码';
            }
            else {
                this.verifyText = '重新获取 ' + newValue + 's';
            }
        }
    },
    computed: {
        desensitizationPhone() {
            return this.userPhone.substring(0, 3) + '****' + this.userPhone.substring(7, 11);
        }
    },
    mounted() {
        // 初始化留资表单
        this.initForm();
    },
    beforeDestroy() {
        this.clearTimer();
    },
    methods: {
        // 查询用户的手机号
        queryUserBindPhone() {
            return new Promise(resolve => {
                client.getUserPhone().then(({data}) => {
                    resolve(data.phone || '');
                }).catch(() => {
                    resolve('');
                });
            });
        },
        // 初始化留资表单
        async initForm() {
            this.userPhone = this.savedPhone || await this.queryUserBindPhone();
            if (!this.userPhone) {
                this.onClickModifyBtn();
            }
            if (!this.savedPhone) {
                this.$emit('saveUserPhone', this.userPhone);
            }
            this.visible = true;
        },
        // 点击同意使用手机号按钮
        onClickAgreeBtn() {
            this.isChecked = !this.isChecked;
        },
        // 发送验证码
        getSmsCode() {
            if (!this.validatePhone() || this.countdown < 60) {
                return;
            }
            this.phoneErrorMessage = '';

            this.countdown = 59;
            this.timer = setInterval(() => {
                if (this.countdown === 0) {
                    this.clearTimer();
                    return;
                }
                this.countdown--;
            }, 1000);

            client.getBkpVerifyCode({
                phone: this.modifyPhone ? this.formData.phone : this.userPhone
            })
            .then(res => {
                if (res && res.data && !res.data.success) {
                    Notification.error({
                        title: '失败',
                        message: '验证码发送失败，请稍后再试',
                        offset: 100,
                        duration: 2000
                    });
                }
            })
            .catch(() => {
                this.clearTimer();
                Notification.error({
                    title: '失败',
                    message: '接口调用失败',
                    offset: 100,
                    duration: 2000
                });
            });
        },
        // 清除 timer
        clearTimer() {
            clearInterval(this.timer);
            this.countdown = 60;
        },
        // 修改手机号
        onClickModifyBtn() {
            this.modifyPhone = true;
        },
        // 关闭留咨弹窗，重置表单
        onClose() {
            this.$emit('onClose');
        },
        // 提交表单
        onSubmit() {
            if (!this.isChecked || !this.validateFields()) {
                return;
            }
            this.phoneErrorMessage = '';
            this.smsCodeErrorMessage = '';

            const phone = this.modifyPhone ? this.formData.phone : this.userPhone;
            client.validCbsVerifyCode({
                phone,
                smsCode: this.formData.smsCode
            })
            .then(res => {
                if (res && res.data && !res.data.success) {
                    this.smsCodeErrorMessage = '验证码错误';
                    return Promise.reject();
                }
                this.onClose();
                this.$emit('onSubmit', this.modifyPhone ? phone : null);
            });
        },
        // 校验表单
        validateFields() {
            let validate = true;
            if (!this.validatePhone()) {
                validate = false;
            }
            if (!this.validateSmsCode()) {
                validate = false;
            }
            return validate;
        },
        // 电话号码校验
        validatePhone() {
            if (this.modifyPhone) {
                let phone = this.formData.phone;
                if (!phone) {
                    this.phoneErrorMessage = '请输入手机号码';
                    return false;
                }
                // 校验输入的电话号格式
                if (!/^1[0-9]{10}$/.test(phone)) {
                    this.phoneErrorMessage = '手机号码格式错误';
                    return false;
                }
            }
            return true;
        },
        // 校验验证码
        validateSmsCode() {
            let smsCode = this.formData.smsCode;
            if (!smsCode) {
                this.smsCodeErrorMessage = '请输入验证码';
                return false;
            }
            if (!/^[0-9]{6}$/.test(smsCode)) {
                this.smsCodeErrorMessage = '验证码格式错误';
                return false;
            }
            return true;
        }
    }
};
</script>

<style lang="less" scoped>
.verify-user-phone-dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .16);
    .verify-user-phone-dialog {
        width: 500px;
        min-height: 334px;
        padding: 20px 30px;
        background: #FFFFFF;
        .dialog-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .header-title {
                font-family: PingFangSC-Medium;
                font-size: 18px;
                color: #1B1E3F;
                font-weight: 500;
            }
            img {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
        .dialog-content {
            margin-bottom: 20px;
            .tips {
                margin-top: 12px;
                opacity: 0.6;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #1B1E3F;
                font-weight: 400;
            }
            .form {
                margin: 18px 0;
                .form-item {
                    margin-bottom: 20px;
                    display: flex;
                    align-items: flex-start;
                    .form-item-label {
                        min-width: 76px;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        line-height: 40px;
                        color: #1B1E3F;
                        font-weight: 400;
                    }
                    .form-item-value {
                        width: 100%;
                    }
                    .form-item-content {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        background: #FFFFFF;
                        border: 1px solid #E0E0E0;
                        border-radius: 2px;
                        display: flex;
                        justify-content: space-between;
                        align-content: center;
                        input {
                            width: 100%;
                            padding: 0 10px;
                            border: none;
                            outline: none;
                            background: none;
                            line-height: 20px;
                            font-family: PingFangSC-Regular;
                            font-size: 14px;
                            color: #1B1E3F;
                            font-weight: 400;
                        }
                        span {
                            vertical-align: middle;
                            font-family: PingFangSC-Regular;
                            font-size: 14px;
                            color: #1B1E3F;
                            font-weight: 400;
                        }
                        .user-phone {
                            margin-left: 10px;
                        }
                        .operate {
                            margin: 0 10px;
                            color: #2A62FE;
                            cursor: pointer;
                            white-space: nowrap;
                        }
                        .time-loading {
                            opacity: 0.6;
                            cursor: default;
                        }
                        &:hover {
                           border: 1px solid #2A62FE;
                           input {
                               color: #2A62FE;
                           }
                        }
                    }
                    .form-item-error {
                        font-size: 12px;
                        padding: 3px 0;
                        color: #d0021b;
                        height: 0;
                    }
                    .disabled {
                        background: #F6F7FA;
                        &:hover {
                           border: 1px solid #E0E0E0;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            .protocol {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #1B1E3F;
                line-height: 20px;
                font-weight: 400;
                .agree-protocol {
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border: 1px solid #E0E0E0;
                    border-radius: 2px;
                    cursor: pointer;
                    margin-right: 10px;
                    vertical-align: middle;
                }
                .checked {
                    background: url(../assets/verify-user-agree-protocol.png) no-repeat;
                    background-size: 100% 100%;
                    border: none;
                }
                a {
                    color: #2A62FE;
                    text-decoration: none;
                }
            }
        }
        .dialog-footer {
            display: flex;
            justify-content: center;
            button {
                width: 160px;
                height: 40px;
                vertical-align: middle;
                text-align: center;
                border-radius: 4px;
                font-size: 16px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                cursor: pointer;
            }
            .cancel-btn {
                margin-right: 30px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #2A62FE;
                font-weight: 400;
                border: 1px solid #2A62FE;
                background: #FFFFFF;
            }
            .submit-btn {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #FFFFFF;
                font-weight: 400;
                background: #2A62FE;
                border: none;
            }
            .disabled {
                opacity: 0.4;
                cursor: default;
            }
        }
    }
}
</style>